var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wrapper",staticClass:"voc-watermark-container",style:(_vm.style)},[_c('canvas',{ref:"canvas",staticClass:"voc-watermark-canvas",staticStyle:{"width":"100%","height":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }